import { createSelector } from 'reselect';
import { dataFormatterUtils, sort } from 'utils';

const getPlayerData = (state: any) => state.playerReportReducer.playerData;
const playerCurrencyId = (state: any) => state.playerReportReducer.currencyId;
const getPlayerTotalLineData = (state: any) => state.playerReportReducer.total;
const getSortedPlayerData = (state: any) => state.playerReportReducer.sortedPlayerData;
const getPromotionData = (state: any) => state.playerReportReducer.promotionData;
const getCampaignsData = (state: any) => state.playerReportReducer.campaignsData;
const getPaginationData = (state: any) => state.playerReportReducer.pagination;
const getPlayerInternalIdData = (state: any) => state.playerReportReducer.playerInternalId;
const playerDoesntExistData = (state: any) => state.playerReportReducer.playerDoesntExist;
const getFilters = (state: any) => state.playerReportReducer.filters;
const getIsLoading = (state: any) => state.playerReportReducer.isLoading;

export const getPlayerRawData = createSelector(getPlayerData, (state) => state);
export const getPlayer = createSelector(
    getPlayerData,
    (state) =>
        state &&
        sort(
            {
                keyToSort: 'endTime',
                sortState: 'desc',
            },
            dataFormatterUtils.getFormattedData(state, false),
        ),
);
export const getPromotion = createSelector(getPromotionData, (state) => state);
export const getPlayerCampaigns = createSelector(getCampaignsData, (state) => state);
export const getPlayerCurrencyId = createSelector(playerCurrencyId, (state) => state);
export const getPlayerTotalLine = createSelector(getPlayerTotalLineData, (state) => state);
export const getSortedPlayer = createSelector(getSortedPlayerData, (state) => state);
export const getPlayerInternalId = createSelector(getPlayerInternalIdData, (state) => state);
export const playerDoesntExist = createSelector(playerDoesntExistData, (state) => state);
export const getPlayerPagination = createSelector(getPaginationData, (state) => state);
export const getPlayerLoading = createSelector(getIsLoading, (isLoading) => isLoading);

// Filter selectors
export const getPlayerFilters = createSelector(getFilters, (filters) => filters);

export const getRoundId = createSelector(getFilters, (filters) => filters.roundId);
export const getDateRange = createSelector(getFilters, (filters) => ({
    fromDate: filters.fromDate,
    toDate: filters.toDate,
}));
export const getRoundTypes = createSelector(getFilters, (filters) => filters.roundTypes);
export const getSortParams = createSelector(getFilters, (filters) => ({
    sortBy: filters.sortBy,
    sortOrder: filters.sortOrder,
}));
export const getPaginationParams = createSelector(getFilters, (filters) => ({
    currentPage: filters.currentPage,
    pageSize: filters.pageSize,
}));

// Derived state selectors
export const isRoundIdSearchMode = createSelector(
    getRoundId,
    (roundId) => !!roundId && roundId.trim().length > 0
);

export const hasActiveDateFilter = createSelector(
    getFilters,
    (filters) => !!filters.fromDate && !!filters.toDate
);

export const shouldOmitDates = createSelector(
    isRoundIdSearchMode,
    (isRoundIdMode) => isRoundIdMode
);

export const getEffectiveFilters = createSelector(
    [getRoundId, getDateRange, isRoundIdSearchMode],
    (roundId, dateRange, isRoundIdMode) => ({
        roundId: roundId?.trim() || null,
        fromDate: isRoundIdMode ? null : dateRange.fromDate,
        toDate: isRoundIdMode ? null : dateRange.toDate,
    })
);
